import type { ComponentProps } from "react";

export function BuyMeACoffeeIcon(props: ComponentProps<"img">) {
  return <img {...props} src="/static/buy-me-a-coffee.svg" alt="" />;
}
